import { Component, OnInit, ViewChild } from '@angular/core';
import { UtilitiesCreateEditComponent } from './utilities-create-edit/utilities-create-edit.component';
import { ModalConfirmComponent } from '../modal-confirm/modal-confirm.component';
import { IAppliedFilter } from 'src/app/interface/applied-filter';
import { UtilityService } from 'src/app/services/http/utility.service';
import { IFilterResponse } from 'src/app/interface/filter-response';
import { ToastrService } from 'ngx-toastr';
@Component({
  selector: 'app-utilities-management',
  templateUrl: './utilities-management.component.html',
  styleUrls: ['./utilities-management.component.scss']
})
export class UtilitiesManagementComponent {
    @ViewChild(UtilitiesCreateEditComponent) popupComponentRef!: UtilitiesCreateEditComponent;
    @ViewChild(ModalConfirmComponent) confirmModal!: ModalConfirmComponent;

    appliedFilters: IAppliedFilter[] = []
    searchInput: string = '';
    public currentPage: number = 1;
    public pageSize: number = 10;
    public count: number = 0;
    public selectedUtility: any = {
        id: "",
        name: '',
        applications: [],
    };;
    public utilities: any[] = []

    ngOnInit(): void {
    this.reloadTable();
    }

    constructor(private utilityService: UtilityService,
    private toastr: ToastrService) { }

    handleChangeFilter(appliedFilters: IFilterResponse) {
        this.appliedFilters = appliedFilters.filters;
        this.searchInput = appliedFilters.searchFilter;
        this.currentPage = 1;
        this.reloadTable()
    }

    pageChange(value: number) {
        this.currentPage = value
        this.reloadTable()
    }

    resetSelectedBU() {
        this.selectedUtility = {
            id: "",
            name: '',
            applications: []
        };
    }

    reloadTable(page: any = null) {
        if (page)
            this.currentPage = page;

        this.resetSelectedBU();

        let obj = {
            pageInfo: {
            page: this.currentPage,
            pageSize: this.pageSize,
            },
            search: this.searchInput
        };

        this.utilityService.getAll(obj).subscribe(response => {
            this.utilities = response.data.data;
            this.count = response.data.count;
        }, error => {
            this.toastr.error('An error occurred.');
        });
    }

    selectUtility (id?: any) {
    if (id != null) {
        let tempUser = this.utilities.find(x => x.id === id);
        this.openTab(tempUser);
    }
    else
        this.openTab();
    }

    openTab(data?: any) {
    if (data) {
        this.popupComponentRef.changeState(1, data);
    }
    else {
        this.popupComponentRef.changeState(1);
    }
    }

    openTabDelete(id: any) {
        this.selectedUtility = this.utilities.find(x => x.id === id);
        this.confirmModal.changeState();
    }

    cancelDelete() {

    }
}